/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/*
* A map of Predict Vis Recommender info to Explore's.
*/
define({
	Area: {
		visId: 'com.ibm.vis.rave2bundlearea',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	StackedArea: {
		visId: 'com.ibm.vis.rave2bundlearea',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Bar: {
		visId: 'com.ibm.vis.rave2bundlebar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredBar: {
		visId: 'com.ibm.vis.rave2bundlebar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	StackedBar: {
		visId: 'com.ibm.vis.rave2bundlestackedbar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Bubble: {
		visId: 'com.ibm.vis.ravebubble',
		X:  'x',
		Y: 'y',
		SIZE: 'size',
		COLOR: 'color',
		POINTS :'categories',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Column: {
		visId: 'com.ibm.vis.rave2bundlecolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredColumn: {
		visId: 'com.ibm.vis.rave2bundlecolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	StackedColumn: {
		visId: 'com.ibm.vis.rave2bundlestackedcolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Crosstab: {
		visId: 'crosstab',
		VALUE: 'values',
		CATEGORY: 'column_level1',
		COLUMN_HIERARCHY: 'column_level1',
		ROW_HIERARCHY: 'row_level1',
		COLOR: 'heat'
	},
	Heatmap : {
		visId: 'com.ibm.vis.rave2heat',
		ROW: 'categories',
		COLUMN: 'series',
		COLOR: 'color',
		SIZE: 'size',
		POINTS: 'points',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Line : {
		visId: 'com.ibm.vis.rave2line',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredLine : {
		visId: 'com.ibm.vis.rave2line',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	DualAxis : {
		visId: 'com.ibm.vis.rave2bundlecomposite',
		CATEGORY: 'categories',
		Y1: 'lineValue',
		Y2: 'columnValue',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Tiledmap: {
		visId: 'com.ibm.vis.rave2bundletiledmap',
		REGION_LOCATION: 'locations',
		REGION_COLOR: 'locationColor',
		POINT_LOCATION: 'pointLocations',
		POINT_COLOR: 'pointColor',
		POINT_SIZE: 'pointSize',
		COORDINATE_LATITUDE: 'latlongLocations.latitude',
		COORDINATE_LONGITUDE: 'latlongLocations.longitude',
		COORDINATE_COLOR: 'latlongColor',
		COORDINATE_SIZE: 'latlongSize',
		COORDINATE_LABEL: 'latlongLocations.caption'
	},
	PackedBubble: {
		visId: 'com.ibm.vis.rave2bundlepackedbubble',
		CATEGORY: 'categories',
		COLOR: 'color',
		SIZE: 'size',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	HierarchicalPackedBubble: {
		visId: 'com.ibm.vis.rave2bundlehierarchicalpackedbubble',
		CATEGORY: 'categories',
		HIERARCHY: 'categories',
		COLOR: 'color',
		SIZE: 'size',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Pie: {
		visId: 'com.ibm.vis.rave2bundlepie',
		CATEGORY: 'categories',
		VALUE: 'values',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	HierarchicalPie: {
		visId: 'com.ibm.vis.rave2bundlepie',
		HIERARCHY: 'categories',
		VALUE: 'values',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Point: {
		visId: 'com.ibm.vis.rave2point',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredPoint: {
		visId: 'com.ibm.vis.rave2point',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Dial: {
		visId: 'com.ibm.vis.rave2bundleradialbar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Scatter: {
		visId: 'com.ibm.vis.ravescatter',
		X: 'x',
		Y: 'y',
		COLOR: 'color',
		POINTS: 'categories',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Singleton: {
		visId: 'summary',
		VALUE: 'values'
	},
	List: {
		visId: 'JQGrid',
		ANY: 'grid_cols'
	},
	Treemap: {
		visId: 'com.ibm.vis.rave2bundletreemap',
		HIERARCHY: 'categories',
		CATEGORY: 'categories',
		SIZE: 'size',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Wordle: {
		visId:'com.ibm.vis.rave2bundlewordcloud',
		CATEGORY: 'categories',
		SIZE: 'size',
		COLOR: 'color',
		MATRIX_COLUMN : 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Spiral: {
		visId: 'com.ibm.vis.spiral',
		TARGET: 'values'
	},
	Tree: {
		visId: 'com.ibm.vis.decisiontree',
		TARGET: 'values'
	},
	KPI: {
		visId: 'kpi',
		ACTUAL: 'actual',
		PLANNED: 'goal'
	}
});



// WEBPACK FOOTER //
// ./src/js/util/PredictToVizMapping.js